"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIP712_VERSIONS = exports.EIP712_NAME = void 0;
exports.EIP712_NAME = 'EAS';
exports.EIP712_VERSIONS = ['0.26', '1.0.0', '1.0.1', '1.0.2', '1.1.0', '1.2.0', '1.3.0', '1.4.0'];
//# sourceMappingURL=versions.js.map